import {
  CartActionTypes,
  SET_CART_DATA,
  SET_CART_ID,
  SET_CART_SUGGESTION,
  CLEAR_CART_STATE,
  SCAN_CART_ID,
  CartState,
  SET_FORCE_CART,
  SET_CART_TYPE,
  SET_COMPANY_ID,
  FETCH_CART_DATA,
  SET_SORT_ID,
  HANDLE_CART_FAILURE_RESPONSE,
  SET_RX_ENABLED,
} from "../types/CartTypes";
import { IPayloadWrapper } from "../types/PayloadWrapper";
import { ISortCartResultModel } from "../../interfaces/SortCart/ISortCartResultModel";
import { SortType } from "../../../utils/Constants";

/**
 * -------------------------------------
 * Action Creator definitions
 * -------------------------------------
 * */
export const setCartSuggestion = (payload: IPayloadWrapper<number>): CartActionTypes => {
  return {
    type: SET_CART_SUGGESTION,
    payload,
  };
};

export const setCartID = (payload: IPayloadWrapper<number>): CartActionTypes => {
  return {
    type: SET_CART_ID,
    payload,
  };
};

export const setCartData = (
  payload: ISortCartResultModel,
  meta: { setCart: () => void }
): CartActionTypes => {
  return {
    type: SET_CART_DATA,
    payload,
    meta,
  };
};

export const fetchCartData = (payload: {
  setCart: () => void;
  showInstruction: () => void;
  showWarningModal: () => void;
}): CartActionTypes => {
  return {
    type: FETCH_CART_DATA,
    payload,
  };
};

export const clearCartState = (): CartActionTypes => {
  return {
    type: CLEAR_CART_STATE,
  };
};

export const scanCartID = (payload: IPayloadWrapper<string>): CartActionTypes => {
  return {
    type: SCAN_CART_ID,
    payload,
  };
};

export const setForceCart = (payload: IPayloadWrapper<boolean>): CartActionTypes => {
  return {
    type: SET_FORCE_CART,
    payload,
  };
};

export const setCartType = (payload: IPayloadWrapper<number>): CartActionTypes => {
  return {
    type: SET_CART_TYPE,
    payload,
  };
};

export const setCompanyID = (payload: IPayloadWrapper<number>): CartActionTypes => {
  return {
    type: SET_COMPANY_ID,
    payload,
  };
};

export const setSortID = (payload: IPayloadWrapper<number>): CartActionTypes => {
  return {
    type: SET_SORT_ID,
    payload,
  };
};

export const setRXEnabled = (payload: IPayloadWrapper<boolean>): CartActionTypes => {
  return {
    type: SET_RX_ENABLED,
    payload,
  };
};

export const handleCartFailureResponse = (
  payload: ISortCartResultModel,
  meta: { showInstruction: () => void; showWarningModal: () => void }
) => {
  return {
    type: HANDLE_CART_FAILURE_RESPONSE,
    payload,
    meta,
  };
};

const initialCartState: CartState = {
  cartSuggestion: -1,
  cartType: -1,
  sortType: -1,
  rxEnabled: true,
  isRXSingle: false,
  sortID: -1,
  isSingleCart: false,
  isMultiCart: false,
  forceCart: false,
  currentCart: -1,
  companyID: -1,
  workstationType: 0,
  locationHistory: [],
  hasHelpPicklist: false
};

/**
 * -------------------------------------
 * Reducer definition
 * -------------------------------------
 * */
const reducer = (state = initialCartState, action: CartActionTypes): CartState => {
  switch (action.type) {
    case SET_CART_ID:
      return { ...state, currentCart: action.payload.value };
    case SET_CART_DATA:
      return {
        ...state,
        cartType: action.payload.cartType,
        sortType: action.payload.sortType,
        rxEnabled: action.payload.rxEnabled,
        isRXSingle: action.payload.isRXSingel,
        sortID: action.payload.sortID,
        isSingleCart:
          action.payload.sortType === SortType.SINGEL ||
          action.payload.sortType === SortType.AFRAMEMIXEDSINGLE,
        forceCart: false,
        companyID: action.payload.companyID,
        workstationType: action.payload.workstationType,
        locationHistory: action.payload.locationHistory,
        hasHelpPicklist: action.payload.hasHelpPicklist,
      };
    case SET_CART_SUGGESTION:
      return { ...state, cartSuggestion: action.payload.value };
    case CLEAR_CART_STATE:
      return {
        ...initialCartState,
      };
    case SET_FORCE_CART:
      return { ...state, forceCart: action.payload.value };
    case SET_COMPANY_ID:
      return { ...state, companyID: action.payload.value };
    case SET_SORT_ID:
      return { ...state, sortID: action.payload.value };
    case SET_RX_ENABLED:
      return { ...state, rxEnabled: action.payload.value };
    default:
      return state;
  }
};

/**
 * -------------------------------------
 * Public interface
 * -------------------------------------
 * */
export default reducer;
